// HR Report Permissions
//
// ⚠️ RECONCILE BEFORE RELEASE. Same allocation caveat as employeeLoans.js —
// 1566-1571 are counted forward from the confirmed 1522 — derived, not read.
// Confirm off the live rows:
//
//     SELECT id, name FROM permissions WHERE name LIKE 'reports.hr.%';
export const HR_REPORTS_PAYROLL_REGISTER = 1566;
export const HR_REPORTS_GOSI_CONTRIBUTIONS = 1567;
export const HR_REPORTS_END_OF_SERVICE_LIABILITY = 1568;
export const HR_REPORTS_ATTENDANCE_SUMMARY = 1569;
export const HR_REPORTS_LEAVE_BALANCES = 1570;
export const HR_REPORTS_LOANS_OUTSTANDING = 1571;

/**
 * The sidebar's gate for the HR reports group — it lights when the reader holds
 * ANY of them, matching every other report category.
 */
export const HR_REPORTS_PERMISSIONS = [
  HR_REPORTS_PAYROLL_REGISTER,
  HR_REPORTS_GOSI_CONTRIBUTIONS,
  HR_REPORTS_END_OF_SERVICE_LIABILITY,
  HR_REPORTS_ATTENDANCE_SUMMARY,
  HR_REPORTS_LEAVE_BALANCES,
  HR_REPORTS_LOANS_OUTSTANDING,
];
